import { Injectable } from '@angular/core';
import { UpdateAuthUser } from '@app/auth/actions/auth';
import { UserDataService } from '@app/core/services/user-data.service';
import { UserChangePasswordActionTypes, UserChangePasswordFailure, UserChangePasswordSuccess } from '@app/pcs/actions/user-change-password';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mapPayload } from '@util';
import { of } from 'rxjs';
import { catchError, exhaustMap, switchMap } from 'rxjs/operators';

@Injectable()
export class UserChangePasswordEffects {

  changePassword$ = createEffect(() => this.actions$.pipe(
    ofType(UserChangePasswordActionTypes.ChangePassword),
    mapPayload(),
    exhaustMap(({ changePassword, redirectAction }) =>
      this.userDataService.changePassword(changePassword).pipe(
        switchMap(user => [
          new UpdateAuthUser(user),
          new UserChangePasswordSuccess(),
          redirectAction
        ]),
        catchError(() => of(new UserChangePasswordFailure()))
      ))
  ));

  constructor(
    private actions$: Actions,
    private userDataService: UserDataService
  ) {
  }
}
